export default "__VITE_ASSET__673d895b__"